import Dialog from '@/ui/dialog'
import classNames from 'classnames'
import React from 'react'

import { TabsHeader } from '@maxroll-media-group/common-libs'
import styles from './dialog.module.scss'

const activeDialogs: object[] = []
function registerDialog() {
  const obj = {}
  if (!activeDialogs.length) {
    document.body.classList.add(styles.hasDialog)
  }
  activeDialogs.push(obj)
  return () => {
    const index = activeDialogs.indexOf(obj)
    if (index >= 0) activeDialogs.splice(index, 1)
    if (!activeDialogs.length) {
      document.body.classList.remove(styles.hasDialog)
    }
  }
}

export function PlannerDialog({ className, ...props }: Parameters<typeof Dialog>[0]) {
  React.useEffect(registerDialog, [])
  return <Dialog className={classNames(styles.PlannerDialog, className)} {...props} />
}

export function DialogTabs({ className, ...props }: Parameters<typeof TabsHeader<string>>[0]) {
  return (
    <TabsHeader
      className={classNames(styles.DialogTabs, className)}
      activeClass={styles.DialogTabs__active}
      {...props}
    />
  )
}
